import React, { FunctionComponent, useState } from 'react'
import IMTheme from '../../style/IMTheme'
import Row from '../Common/Row'
import { Divider, Text } from '@wework/dieter-ui'
import ReactDOMServer from 'react-dom/server'
import Commitment from './Commitment'
import Hold from './Hold'
import PPWKSection from './PPWKSection'
import Availability from './Availability'
import _ from 'lodash'

interface CollapsableAvailabilityInfoProps {
  isBPO: boolean
  space: any
  onHoldClick: (boolean) => void
}

const CollapsableAvailabilityInfo: FunctionComponent<CollapsableAvailabilityInfoProps> = ({
  isBPO,
  space,
  onHoldClick,
}) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false)

  const availabilityDetails = _.filter(
    [
      <Availability
        key={'Availability' + space.uuid}
        space={space}
        border
        containerStyle={{ marginBottom: 8 }}
      />,
      <PPWKSection
        key={'PPWKSection' + space.uuid}
        //@ts-ignore
        space={space}
        border
        containerStyle={{ marginBottom: 8 }}
      />,
      <Commitment
        key={'Commitment' + space.uuid}
        space={space}
        border
        containerStyle={{ marginBottom: 8 }}
      />,
      <Hold
        key={'Hold' + space.uuid}
        //@ts-ignore
        space={space}
        border
        containerStyle={{ marginBottom: 8 }}
      />,
    ],
    component => ReactDOMServer.renderToStaticMarkup(component)
  )
  const isAvailabilityInfoNotEmpty = availabilityDetails.length > 0
  return (
    <>
      {isAvailabilityInfoNotEmpty && (
        <div>
          <Divider
            light
            style={{
              marginTop: IMTheme.spacing[3],
              marginBottom: IMTheme.spacing[5],
            }}
          />
          <Row
            justify="space-between"
            style={{ marginBottom: IMTheme.spacing[4] }}
          >
            <Text
              style={{
                fontSize: IMTheme.fontSizes[2],
                fontWeight: IMTheme.fontWeights.bold,
              }}
            >
              Availability
            </Text>
            {!isBPO && space?.programType === 'WORK' && space.reservable && (
              <Text
                primary
                style={{
                  fontSize: IMTheme.fontSizes[2],
                  fontWeight: IMTheme.fontWeights.normal,
                  cursor: 'pointer',
                }}
                onClick={() => onHoldClick(true)}
              >
                Hold
              </Text>
            )}
          </Row>
        </div>
      )}
      {isAvailabilityInfoNotEmpty && isCollapsed && availabilityDetails[0]}
      {isAvailabilityInfoNotEmpty && !isCollapsed && availabilityDetails}
      {availabilityDetails.length > 1 && (
        <Row justify="flex-end">
          <Text
            primary
            style={{
              fontSize: IMTheme.fontSizes[2],
              fontWeight: IMTheme.fontWeights.normal,
              cursor: 'pointer',
            }}
            onClick={() => setIsCollapsed(prevState => !prevState)}
          >
            {isCollapsed ? 'More' : 'Less'}
          </Text>
        </Row>
      )}
    </>
  )
}

export default CollapsableAvailabilityInfo
